import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { QuickSkillCommand } from 'src/types';

export interface SkillCommandState {
  activeSkillCommand: QuickSkillCommand | null;
}

const initialState = {
  activeSkillCommand: null,
} as SkillCommandState;

// TODO(olha): rename to skillCommandPersistSlice
export const skillCommandSlice = createSlice({
  name: 'skillCommandPersist',
  initialState,
  reducers: {
    setActiveSkillCommand: (
      state,
      { payload }: PayloadAction<QuickSkillCommand | null>,
    ) => {
      state.activeSkillCommand = payload;
    },
  },
});

export const skillCommandState = (state: RootState) =>
  state.skillCommandPersist as SkillCommandState;

export const { setActiveSkillCommand } = skillCommandSlice.actions;

export default skillCommandSlice.reducer;
